module.exports = __webpack_public_path__ + "static/media/MarkerFelt-Thin.877e35f8.svg";